import apiClient from "@/api/client";
import type { MultisportEntry, MultisportEntryPayload } from "../types";

export const multisportApi = {
  list: () =>
    apiClient
      .get<{ data: MultisportEntry[] }>("/multisport/")
      .then((r) => r.data.data),

  create: (payload: MultisportEntryPayload) =>
    apiClient
      .post<{ data: MultisportEntry }>("/multisport/", payload)
      .then((r) => r.data.data),

  update: (id: string, payload: Partial<MultisportEntryPayload>) =>
    apiClient
      .patch<{ data: MultisportEntry }>(`/multisport/${id}/`, payload)
      .then((r) => r.data.data),

  delete: (id: string) => apiClient.delete(`/multisport/${id}/`),
};
